import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router';
import DrawerMenu from './Menu/DrawerMenu';
import NavMenu from './Menu/NavMenu';

export default function Layout() {
  return (
    <React.Fragment>
      <NavMenu />
      <Box className="content" display="flex">
        <div>
          <DrawerMenu />
        </div>

        <Outlet />
      </Box>

      <footer className="py-3 bg-light">
        <div className="container-fluid px-4">
          <div className="d-flex align-items-center justify-content-center small">
            <div className="text-muted">
              Ministerio de Energía y Minas - <b>{new Date().getFullYear()}</b>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
